export const switchLanguageAction = (language: string) => {
  localStorage.setItem('lang', language);

  return {
    type: 'switchLanguage',
    payload: language,
  };
};
